import React, { useState, useEffect } from 'react'
import { string } from 'prop-types'
import { InfoOutlined, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import Tooltip from 'Pods/Shared/Tooltip'

function ModelCardSponsoredTag({ id }) {
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    setIsLoaded(true)
  }, [])

  const content = isLoaded
    ? 'This item has been promoted by the creator to appear higher in search results using Boost Credits'
    : ''

  return (
    <div className="card-3d-model__sponsored-tag">
      Sponsored
      <Tooltip
        content={content}
        id={`sponsored-tag-${id}`}
      >
        <Icon svgComponent={InfoOutlined} color="dark" size="small" notSpaced />
      </Tooltip>
    </div>
  )
}

ModelCardSponsoredTag.propTypes = {
  id: string.isRequired,
}

export default ModelCardSponsoredTag
